import { render, staticRenderFns } from "./nzSki.vue?vue&type=template&id=63a5792e&scoped=true&"
import script from "./nzSki.vue?vue&type=script&lang=js&"
export * from "./nzSki.vue?vue&type=script&lang=js&"
import style0 from "./nzSki.vue?vue&type=style&index=0&id=63a5792e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a5792e",
  null
  
)

export default component.exports